import { capitalize } from 'inflection';
import { DesignProjectFields } from "../../types/request.types";
import { formatDate } from "../../lib/date-time-formatters";

import classes from "./Request.module.css";

interface DesignProjectProps {
  request: DesignProjectFields;
}

const DesignProject = ({ request }: DesignProjectProps) => (
  <dl className={classes.details}>
    <dt>Name</dt>
    <dd>{request.name}</dd>
    <dt>Project type</dt>
    <dd>{request.project_type && capitalize(request.project_type)}</dd>
    <dt>History</dt>
    <dd>{request.history && capitalize(request.history)}</dd>
    <dt>Quantity</dt>
    <dd>{request.quantity}</dd>
    <dt>Budget code</dt>
    <dd>{request.budget_code}</dd>
    <dt>Content</dt>
    <dd dangerouslySetInnerHTML={{__html: request.content || ''}}></dd>
    <dt>Requested completion date</dt>
    <dd>
      {request.requested_completion_date && formatDate(request.requested_completion_date)}
    </dd>
  </dl>
);

export default DesignProject;
